class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	connectedCallback(){
		// doppel n 22.10.2026: Die Empfehlungen haengen vom Warenkorb ab. Neu laden, sobald sich die
		// Zeilen aendern (Zubehoer aus dem Drawer hinzugefuegt, Zeile entfernt). Diese Wege haben
		// generateRecommendations() vorher nicht aufgerufen.
		const cartForm = document.getElementById('AjaxCartForm');
		if ( ! cartForm || this._observer ) return;
		let timer;
		this._observer = new MutationObserver(() => {
			if ( this.cartKey() === this._lastKey ) return;
			clearTimeout(timer);
			timer = setTimeout(() => this.generateRecommendations(), 150);
		});
		this._observer.observe(cartForm, { childList: true, subtree: true });
	}

	cartKey(){
		const cartForm = document.getElementById('AjaxCartForm');
		if ( ! cartForm ) return '';
		return [...cartForm.querySelectorAll('[data-js-cart-item]')].map(item => item.dataset.id).sort().join(',');
	}

	generateRecommendations(){
		const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
		this._lastKey = this.cartKey();
		if ( cartItems.length > 0 ) {
			// Warenkorb-Stand als Parameter, damit keine zwischengespeicherte Antwort zum alten Warenkorb kommt
			fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}&bs_cart=${encodeURIComponent(this._lastKey)}`)
				.then(response => response.text())
				.then(text => {
					const innerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-js-cart-recommendations-performed]');
          if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
          	this.innerHTML = innerHTML.innerHTML;
          } else {
          	// nichts Passendes mehr uebrig: alten Inhalt nicht stehen lassen
          	this.innerHTML = '';
          }
				})
		}
	}
}
customElements.define('cart-recommendations', CartRecommendations);
